(function () {
  function syncResultsPanel(searchInstance) {
    const panel = searchInstance.querySelector('[data-predictive-search]');
    const inner = searchInstance.closest('.ssw-search-modal__inner');
    if (!panel || !inner) return;

    const isActive =
      searchInstance.getAttribute('open') === 'true' || searchInstance.getAttribute('loading') === 'true';
    if (!isActive) return;

    const innerTop = inner.getBoundingClientRect().top;
    const available = window.innerHeight - innerTop - 48;
    panel.style.maxHeight = `${Math.max(180, available)}px`;
    panel.style.overflowY = 'auto';
  }

  function scrollToResults(searchInstance) {
    const modal = searchInstance.closest('.ssw-search-modal');
    const panel = searchInstance.querySelector('[data-predictive-search]');
    if (!modal || !panel || searchInstance.getAttribute('open') !== 'true') return;
    if (!panel.querySelector('#predictive-search-results')) return;

    syncResultsPanel(searchInstance);

    requestAnimationFrame(() => {
      const panelTop = panel.getBoundingClientRect().top;
      const panelBottom = panel.getBoundingClientRect().bottom;
      const viewportBottom = window.innerHeight - 24;

      if (panelBottom > viewportBottom) {
        modal.scrollTop += panelBottom - viewportBottom;
      }
    });
  }

  function bindSearchInstance(searchInstance) {
    if (searchInstance.dataset.sswSearchBound === 'true') return;
    searchInstance.dataset.sswSearchBound = 'true';

    const panel = searchInstance.querySelector('[data-predictive-search]');
    const input = searchInstance.querySelector('.search__input');
    if (!panel) return;

    const handleUpdate = () => {
      syncResultsPanel(searchInstance);
      scrollToResults(searchInstance);
    };

    const attributeObserver = new MutationObserver(handleUpdate);
    attributeObserver.observe(searchInstance, {
      attributes: true,
      attributeFilter: ['open', 'loading', 'results'],
    });

    const resultsObserver = new MutationObserver(handleUpdate);
    resultsObserver.observe(panel, { childList: true, subtree: true });

    input?.addEventListener('input', () => requestAnimationFrame(handleUpdate));
    window.addEventListener('resize', () => requestAnimationFrame(handleUpdate));
  }

  function init() {
    document.querySelectorAll('.ssw-header-search predictive-search').forEach(bindSearchInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
